import JobSlider from './JobSlider'
export default JobSlider
